import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import DashBoardNavBar from '../components/DashBoardNavBar.tsx';
import Navbar from '../components/Navbar.tsx';
import { Particles } from '../components/Particles.tsx';
import { Box, Typography, Link, List, ListItem, ListItemText, Divider } from '@mui/material';
import { Fade } from '@mui/material'; // Animációhoz
import  TopicBox  from '../components/TopicBox.tsx';

const PaidWebSites: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const isAuthenticated = !!Cookies.get('token'); // Ellenőrzi, hogy van-e token a cookie-ban

  useEffect(() => {
    // Simuláljuk a betöltési időt
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000); // 2 másodperces késleltetés

    return () => clearTimeout(timer);
  }, []);

  // Fizetős weboldalak kategóriái
  const topics = [
    {
      category: 'Design & Creative Tools',
      emoji: '🎨',
      description: 'Premium design tools for creating stunning visuals and professional graphics.',
      links: [
        { name: 'Canva Pro', url: 'https://www.canva.com/pro', emoji: '🖌️', tooltip: 'Design presentations, social media graphics, and more with premium features.' },
        { name: 'Adobe Creative Cloud', url: 'https://www.adobe.com/creativecloud', emoji: '🎥', tooltip: 'Access Adobe\'s suite of creative software, including Photoshop and Illustrator.' },
        { name: 'Shutterstock', url: 'https://www.shutterstock.com', emoji: '📷', tooltip: 'Explore a vast library of stock photos, vectors, and illustrations.' },
        { name: 'Envato Elements', url: 'https://elements.envato.com', emoji: '💎', tooltip: 'Unlimited downloads of design assets, templates, and more.' },
        { name: 'Filmora', url: 'https://filmora.wondershare.net', emoji: '🎬', tooltip: 'User-friendly video editing software with advanced features.' },
        { name: 'Tailornova', url: 'https://tailornova.com', emoji: '👗', tooltip: 'Online fashion design software for creating custom clothing patterns.' },
        { name: 'Pacdora', url: 'https://pacdora.com', emoji: '📦', tooltip: 'Design and visualize packaging with 3D mockups and templates.' },
      ],
    },
    {
      category: 'Marketing & SEO Tools',
      emoji: '📈',
      description: 'Advanced marketing and SEO tools to boost your online presence and analytics.',
      links: [
        { name: 'Semrush', url: 'https://www.semrush.com', emoji: '🔎', tooltip: 'Comprehensive SEO and marketing toolkit for keyword research and competitive analysis.' },
        { name: 'Ahrefs', url: 'https://ahrefs.com', emoji: '📊', tooltip: 'SEO toolset for backlink analysis, keyword research, and site audits.' },
        { name: 'Moz Pro', url: 'https://moz.com/products/pro', emoji: '🛠️', tooltip: 'SEO software offering keyword research, link building, and site audits.' },
      ],
    },
    {
      category: 'Business & Productivity Tools',
      emoji: '💼',
      description: 'Business management and productivity tools to streamline operations and growth.',
      links: [
        { name: 'Salesforce', url: 'https://www.salesforce.com', emoji: '🤝', tooltip: 'Customer relationship management (CRM) platform for sales and marketing.' },
        { name: 'Monday.com', url: 'https://monday.com', emoji: '🗓️', tooltip: 'Work operating system to manage teams, projects, and workflows.' },
        { name: 'QuickBooks', url: 'https://quickbooks.intuit.com', emoji: '💰', tooltip: 'Accounting software for small to medium-sized businesses.' },
        { name: 'Scribehow', url: 'https://scribehow.com', emoji: '📖', tooltip: 'Document and share processes instantly with step-by-step guides.' },
        { name: 'Venngage', url: 'https://venngage.com/ai-tools', emoji: '📊', tooltip: 'Create infographics, reports, and data visualizations with AI-powered tools.' },
      ],
    },
    {
      category: 'Cloud & Hosting Services',
      emoji: '☁️',
      description: 'Reliable cloud and hosting services to power your web applications and infrastructure.',
      links: [
        { name: 'AWS', url: 'https://aws.amazon.com', emoji: '🚀', tooltip: 'Amazon Web Services offers scalable cloud computing solutions.' },
        { name: 'Azure', url: 'https://azure.microsoft.com', emoji: '🌍', tooltip: 'Microsoft\'s cloud platform for building, deploying, and managing applications.' },
        { name: 'DigitalOcean', url: 'https://www.digitalocean.com', emoji: '🌐', tooltip: 'Cloud services for developers to deploy and scale applications.' },
        { name: 'Microsoft OneDrive', url: 'https://www.microsoft.com/hu-hu/microsoft-365/onedrive/free-online-cloud-storage', emoji: '💾', tooltip: 'Cloud storage service for file sharing and collaboration.' },
        { name: 'Heroku', url: 'https://www.heroku.com', emoji: '🔧', tooltip: 'Platform as a service (PaaS) for deploying and managing applications.' },
      ],
    },
    {
      category: 'Development Tools',
      emoji: '💻',
      description: 'Professional development tools to enhance coding efficiency and collaboration.',
      links: [
        { name: 'GitHub Enterprise', url: 'https://enterprise.github.com', emoji: '🐙', tooltip: 'Enterprise-level version control and collaboration platform for code.' },
        { name: 'JetBrains', url: 'https://www.jetbrains.com', emoji: '🔥', tooltip: 'Developer tools for coding, including IntelliJ IDEA and PyCharm.' },
      ],
    },
  ];
  

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      {/* Particles komponens a háttérben */}
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: -1 }}>
        <Particles />
      </div>

      {isAuthenticated ? <DashBoardNavBar /> : <Navbar />}

      <Box sx={{ maxWidth: '100%', margin: 'auto', padding: 3, textAlign: 'center', mt: '64px', }}>
        <Fade in={true} timeout={1000}>
          <Typography variant="h1" sx={{ fontSize: '2.5rem', marginBottom: 2 }}>
            Explore Paid Websites 💎
          </Typography>
        </Fade>
        <Fade in={true} timeout={1500}>
          <Typography variant="body1" sx={{ fontSize: '1.1rem', color: '#8a8888', marginBottom: 4 }}>
            Discover premium tools and services available online. Click on the links below to learn more! 🔗
          </Typography>
        </Fade>

        {/* Flexbox elrendezés a Box-okhoz */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, justifyContent: 'center', paddingTop: 4 }}>
          {topics.map((topic) => (
            <TopicBox key={topic.category} topic={topic} />
          ))}
        </Box>
      </Box>
    </div>
  );
};

export default PaidWebSites;
